import React, { useState } from 'react';
import { RiCalculatorLine } from 'react-icons/ri';

const fmt = (n) => Math.round(Number(n) || 0).toLocaleString('fr-FR');

/**
 * Simulateurs fiscaux indicatifs (Sénégal).
 *
 * ⚠ Estimations simplifiées : les barèmes officiels DGID/IPRES sont plus
 * complexes (tranches progressives, plafonds de cotisation). Les résultats
 * ne constituent pas une déclaration fiscale.
 */
const SimulateurFiscal = () => {
  const [caTtc, setCaTtc] = useState(1000000);
  const [achatsTtc, setAchatsTtc] = useState(300000);
  const [masseSalariale, setMasseSalariale] = useState(850000);

  // TVA 18 % : on extrait la TVA d'un montant TTC (TVA = TTC x 18/118)
  const tvaCollectee = (caTtc * 18) / 118;
  const tvaDeductible = (achatsTtc * 18) / 118;
  const tvaNette = Math.max(0, tvaCollectee - tvaDeductible);

  // Estimations indicatives sur la masse salariale brute
  const vrs = masseSalariale * 0.08;
  const cfce = masseSalariale * 0.03;
  const ipres = masseSalariale * 0.056;
  const css = masseSalariale * 0.07;
  const totalSalaires = vrs + cfce + ipres + css;

  return (
    <div className="row">
      <div className="col-lg-6">
        <div className="fisc-panel">
          <div className="fisc-panel-header">
            <RiCalculatorLine size={20} className="fisc-panel-icon" />
            <div>
              <h3>Simulateur TVA Sénégal (18 %)</h3>
              <p>TVA collectée et déductible sur les opérations mensuelles</p>
            </div>
          </div>
          <div className="form-group">
            <label className="fw-bold small">Chiffre d&rsquo;affaires mensuel TTC (FCFA)</label>
            <input
              type="number"
              className="form-control"
              value={caTtc}
              onChange={(e) => setCaTtc(Number(e.target.value))}
            />
          </div>
          <div className="form-group mt-3">
            <label className="fw-bold small">Achats &amp; charges TTC déductibles (FCFA)</label>
            <input
              type="number"
              className="form-control"
              value={achatsTtc}
              onChange={(e) => setAchatsTtc(Number(e.target.value))}
            />
          </div>
          <div className="fisc-simu-result">
            <div><span>TVA collectée :</span><b>{fmt(tvaCollectee)} FCFA</b></div>
            <div><span>TVA déductible :</span><b className="text-danger">- {fmt(tvaDeductible)} FCFA</b></div>
            <div className="fisc-simu-total">
              <span>NET TVA à reverser :</span><b>{fmt(tvaNette)} FCFA</b>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-6">
        <div className="fisc-panel">
          <div className="fisc-panel-header">
            <RiCalculatorLine size={20} className="fisc-panel-icon" />
            <div>
              <h3>Simulateur impôts sur salaires (VRS &amp; CFCE)</h3>
              <p>Estimation des retenues à la source salariales mensuelles</p>
            </div>
          </div>
          <div className="form-group">
            <label className="fw-bold small">Masse salariale brute du mois (FCFA)</label>
            <input
              type="number"
              className="form-control"
              value={masseSalariale}
              onChange={(e) => setMasseSalariale(Number(e.target.value))}
            />
          </div>
          <div className="fisc-simu-result">
            <div><span>VRS (IR salaires ~8 %) :</span><b>{fmt(vrs)} FCFA</b></div>
            <div><span>CFCE employeur (3 %) :</span><b>{fmt(cfce)} FCFA</b></div>
            <div><span>IPRES retraite (~5,6 %) :</span><b>{fmt(ipres)} FCFA</b></div>
            <div><span>CSS sécurité sociale (7 %) :</span><b>{fmt(css)} FCFA</b></div>
            <div className="fisc-simu-total">
              <span>TOTAL ESTIMÉ NORMES DGID/IPRES :</span><b>{fmt(totalSalaires)} FCFA</b>
            </div>
          </div>
          <div className="alert alert-info py-2 mt-3" style={{ fontSize: 12 }}>
            Estimations indicatives : les barèmes officiels DGID/IPRES
            (tranches, plafonds) ne sont pas reproduits. Ceci ne constitue pas
            une déclaration fiscale.
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimulateurFiscal;
